import React, {useContext, useEffect, useState} from 'react';
import Slider from "react-slick";
import {Link} from "react-router-dom";
import {axios} from "../../axios";
import {LangContext} from "../../App";
import {handleImageUrl} from "../../helpers";

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical:true,
    verticalSwiping: true,
    autoplay:true,
    autoplaySpeed: 2000,
    cssEase: "linear"
};

const HomeEuro = () => {
    const [tours, setTours] = useState([]);
    const lang = useContext(LangContext)

    useEffect(() => {
        axios.get(`${lang}/other-tour?main_page=true`).then(res => {
            if (Array.isArray(res.data.tours)) {
                setTours(res.data.tours);
            } else {
                console.error('API response is not an array:', res.data);
            }
        }).catch(error => {
            console.error('Error fetching tours:', error);
        });
    }, [lang]);

    const content = {
        en:{
            pageTitle:'Europe Tours',
            text:'Discover Europe on carefully designed journeys that combine culture, history, and local life. From world-famous cities to hidden gems, each itinerary is authentic, comfortable, and full of meaning.',
        },
        de:{
            pageTitle: 'Europäische Reisen',
            text:'Entdecken Sie Europa auf sorgfältig gestalteten Reisen, die Kultur, Geschichte und das lokale Leben vereinen. Von weltbekannten Städten bis zu verborgenen Orten – jede Route ist authentisch, komfortabel und voller Bedeutung.',
        }

    }

    const {pageTitle,text} = content[lang] || content.en

    return (
        <div className='home-abroad'>
            <div className="center-wrapper" style={{flexDirection : 'row-reverse', gap:'10px'}}>
                <aside className='desc' style={{
                    display:'flex',
                    flexDirection:'column',
                    alignItems:'flex-end'
                }}>
                    <h2 style={{textAlign:'right'}}>{pageTitle}</h2>
                    <p style={{textAlign:'right'}}>{text}</p>
                </aside>
                <aside className="abroad-slider">
                    <Slider {...settings}>
                        {tours.map(e => {
                            if (!e) return null;
                            const image = handleImageUrl(e.thumbnail)
                            return (
                                <Link key={e.id} to={`/other-tour/${e.id}`}>
                                    <div className='abroad-item'>
                                        {image && <img src={image} alt={e.title} />}
                                        <h3>{e.title}</h3>
                                    </div>
                                </Link>
                            )
                        })}
                    </Slider>
                </aside>
            </div>
        </div>
    );
};

export default HomeEuro;